import { useState } from 'react';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormSubComponent from 'modules/ui/editform/subForm/EditFormSubComponent';
import SensorTypeEditService from '../service/SensorTypeEditService';

const config = data => {
	return {
		key: 'sensorTypeEditForm',
		text: 'Sensor Type',
		textKey: 'sensorType',
		service: SensorTypeEditService,
		tabList: [
			{
				key: 'info',
				text: 'Info',
				textKey: 'info'
			},
			{
				key: 'valueList',
				text: 'Values',
				textKey: 'valueList'
			}
		],
		fields: [
			{
				key: 'name',
				text: 'Name',
				textKey: 'name',
				component: EditFormTextField,
				required: true
			},
			{
				key: 'manufacturer',
				text: 'Manufacturer',
				textKey: 'manufacturer',
				component: EditFormTextField,
				required: false
			},
			{
				key: 'modelId',
				text: 'Model ID',
				textKey: 'modelId',
				component: EditFormTextField,
				required: true
			},
			{
				key: 'externalId',
				text: 'External ID',
				textKey: 'externalId',
				component: EditFormTextField,
				type: 'number',
				required: true
			},
			{
				key: 'edaTypeList',
				text: 'Available EDA Types',
				textKey: 'edaTypeList',
				component: EditFormSelectField,
				items: data.formData.entityMap.edaType,
				multiple: true
			},
			{
				key: 'maxSamplingRate',
				text: 'Max sampling rate of sensor',
				textKey: 'maxSamplingRate',
				component: EditFormTextField,
				type: 'number'
			},
			{
				key: 'valueList',
				text: 'Values',
				textKey: 'valueList',
				tab: 'valueList',
				component: EditFormSubComponent,
				watchTitleKey: 'name',
				defaultValue: {
					id: null,
					name: null,
					type: null
				},
				fields: [
					{
						key: 'name',
						text: 'Name',
						textKey: 'name',
						component: EditFormTextField,
						required: true
					},
					{
						key: 'type',
						text: 'Type',
						textKey: 'type',
						component: EditFormSelectField,
						type: 'enum',
						required: true,
						items: data.formData.enumMap['valueList.type']
					},
					{
						key: 'externalId',
						text: 'External ID',
						textKey: 'externalId',
						component: EditFormTextField,
						type: 'number',
						required: true
					}
				]
			}
		]
	};
};

function SensorTypeEditForm() {
	const [formData, setFormData] = useState(null);
	if (formData == null) {
		SensorTypeEditService.getFormData().then(result => setFormData(result));
		return <></>;
	}
	const myConfig = config({ formData });
	return <EditFormPage config={myConfig} />;
}

export default SensorTypeEditForm;
